<template>
  <div class="doc-feedback-container">
    <div
      v-if="feedbackSuccess"
      class="feedback-success"
    >
      <img src="./img/good.gif">
      <div class="feedback-success-h">
        感谢您的反馈！
      </div>
    </div>
    <div
      v-else
      class="feedback-content"
    >
      <div class="feedback-h">
        这篇文档对您是否有帮助？
      </div>
      <div
        class="feedback-btn-group"
      >
        <div
          :class="['feedback-btn', { active: helpStatus === 'yes' }]"
          @click="setHelpStatus('yes')"
        >
          <img src="./img/help.png">有帮助
        </div>
        <div
          :class="['feedback-btn', { active: helpStatus === 'no' }]"
          @click="setHelpStatus('no')"
        >
          <img src="./img/no_help.png">没帮助
        </div>
      </div>
      <div
        v-if="helpStatus === 'no'"
        class="feedback-form"
      >
        <div class="feedback-h">
          您是否遇到以下问题？
        </div>
        <t-checkbox-group
          v-model="checkedQuestions"
          :options="questions"
        />
        <div class="feedback-h">
          建议反馈
        </div>
        <t-textarea
          v-model="feedbackText"
          placeholder="请输入"
        />
        <div class="btn-container">
          <t-button
            theme="primary"
            variant="base"
            class="submit-btn"
            @click="onSubmit"
          >
            提交
          </t-button>
          <t-button
            variant="outline"
            class="cancel-btn"
            @click="onCancel"
          >
            取消
          </t-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import beaconRequest from '~/utils/beaconRequest';
import utils from '~/utils/index';

export default {
  name: 'DocFeedback',
  data() {
    return {
      helpStatus: '',
      feedbackSuccess: false,
      checkedQuestions: [],
      questions: ['内容错误', '缺少代码/图片示例', '内容看不懂', '内容缺失、找不到', '其他'],
      feedbackText: ''
    };
  },
  methods: {
    setHelpStatus(status) {
      this.helpStatus = status;
      if (status === 'yes') {
        this.feedbackSuccess = true;
        beaconRequest('click_lbs_document_feedback', {
          is_document_help: '是',
          document_question: '',
          document_feedback: '',
          document_url: location.href,
          document_user_id: utils.getCookie('user_uin') || '',
        });
      }
    },
    onSubmit() {
      this.feedbackSuccess = true;
      beaconRequest('click_lbs_document_feedback', {
        is_document_help: '否',
        document_question: this.checkedQuestions.join(';'),
        document_feedback: this.feedbackText,
        document_url: location.href,
        document_user_id: utils.getCookie('user_uin') || '',
      });
    },
    onCancel() {
      this.helpStatus = '';
      this.feedbackSuccess = false;
      this.feedbackText = '';
      this.checkedQuestions = [];
    }
  }
};
</script>
<style lang="less" scope>
.feedback-content {
  padding: 16px 20px;
  background-color: #f5f9ff;
  border-radius: 12px;
  line-height: 22px;
  font-size: 14px;
  .feedback-h {
    margin-bottom: 8px;
    font-weight: 600;
  }
  .feedback-btn-group {
    display: flex;
    gap: 8px;
    .feedback-btn {
      display: flex;
      align-items: center;
      padding: 4px 10px;
      border-radius: 25px;
      border: 1px solid rgba(0, 117, 255, 0.16);
      cursor: pointer;
      > img {
        width: 20px;
        height: 20px;
        margin-right: 3px;
      }
      &.active {
        border: 1px solid #0075FF;
        background-color: rgba(0, 117, 255, 0.10);
      }
    }
  }
  .feedback-form {
    margin-top: 20px;
    .t-checkbox-group {
      flex-direction: column;
      --td-brand-color: #146FFF;
      gap: 6px;
      margin-bottom: 20px;
      .t-checkbox {
        display: flex;
      }
    }
    .t-textarea {
      font: var(--td-font-body-medium);
      color: var(--td-text-color-primary);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      position: relative;
      width: 100%;
    }
    .t-textarea__inner {
      display: flex;
      width: 100%;
      height: var(--td-comp-size-xxxl);
      border: 1px solid var(--td-border-level-2-color);
      border-radius: var(--td-radius-default);
      padding: calc(calc(var(--td-comp-size-m) - var(--td-line-height-body-medium)) / 2) var(--td-comp-paddingLR-s);
      background-color: var(--td-bg-color-specialcomponent);
      font: var(--td-font-body-medium);
      color: var(--td-text-color-primary);
      resize: vertical;
      outline: none;
      transition: all cubic-bezier(.38,0,.24,1) .2s, height 0s;
      box-sizing: border-box;
    }
    .btn-container {
      margin-top: 20px;
      display: flex;
      gap: 8px;
      .t-button {
        width: 52px;
      }
      .submit-btn {
        background: linear-gradient(90deg, #0071FF 0%, #00A3FF 100%);
        border: 0;
        border-radius: 6px;
      }
      .cancel-btn {
        border: 0;
        border-radius: 6px;
      }
    }
  }
}
.feedback-success {
  padding: 10px 0px;
  width: 224px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 12px;
  background: #f5f9ff;
  img {
    width: 60px;
  }
  .feedback-success-h {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
}
</style>
